export default "__VITE_ASSET__CIfhliFd__"